import React from 'react';

import { Button, styled } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Home, Schedule, Templates } from './Icons';
import { ActivePage } from './types';

const Container = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.palette.divider};
    background-color: ${(props) => props.theme.palette.background.default};
    height: 50px;
`;

const NavigationButton = styled(Button)`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 0;
    padding: 5px;
    margin: -5px 0;
    background-color: transparent;
    width: 85px;
    svg {
        height: 14px;
    }
    color: ${(props) => props.theme.palette.text.primary};
`;

const PageName = styled('span')`
    line-height: 1.1;
    margin-top: 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 11px;
    width: 100%;
    text-align: center;
`;

interface NavigationBarInterface {
    activePage: ActivePage;
}

// @NOTE: this attempts to match the styling that we already have in through the jQuery app, for smooth transitions between the two
const NavigationBar: React.FC<NavigationBarInterface> = ({ activePage }) => {
    const { t } = useTranslation('index_client');
    const { search } = useLocation();

    const goToHomePage = () => {
        window.location.replace(`/v1_index_client.html${search}`);
    };

    const goToSchedulePage = () => {
        window.location.replace(`/schedule/v1_schedule.html${search}`);
    };

    const gotToTemplatesPage = () => {
        // Not yet implemented, currently done outside of react pages
    };

    // @NOTE: this does not reactify the user's settings in the top right corner,
    // to access they'll need to navigate back to the homepage (jQuery page) for now
    return (
        <Container>
            <NavigationButton onClick={goToHomePage}>
                {activePage === ActivePage.HOME ? <Home.Active /> : <Home.Inactive />}
                <PageName>{t('home')}</PageName>
            </NavigationButton>
            <NavigationButton onClick={goToSchedulePage}>
                {activePage === ActivePage.SCHEDULE ? <Schedule.Active /> : <Schedule.Inactive />}
                <PageName>{t('class-schedule-nav-button')}</PageName>
            </NavigationButton>
            <NavigationButton onClick={gotToTemplatesPage}>
                {activePage === ActivePage.TEMPLATES ? <Templates.Active /> : <Templates.Inactive />}
                <PageName>{t('template-manager')}</PageName>
            </NavigationButton>
        </Container>
    );
};

export default NavigationBar;
